import $ from 'jquery';

const GotoUpcomingSeminars = (el) => {
    $(el).on('click', () => {
        const $upcomingSeminar = $('.js-upcoming-seminar:first');

        if ($upcomingSeminar.length) {
            const offsetTop = $upcomingSeminar.offset().top;

            $('html, body').animate({
                scrollTop: offsetTop - 200,
            }, 500);
        }
    });
};

export default GotoUpcomingSeminars;
